/**
 * Format allergens array as "(1,2,3)" for inline display.
 */
export function formatAllergens(allergens) {
  if (!Array.isArray(allergens) || allergens.length === 0) return "";
  const nums = [...new Set(allergens)]
    .map(Number)
    .filter(Number.isFinite)
    .sort((a, b) => a - b);
  if (nums.length === 0) return "";
  return `(${nums.join(",")})`;
}
